import $$ from 'cmn-utils'

const baseUrl = "/api/device/part/";
export default {
    list: (params) => {
       return $$.get(baseUrl+'list',params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    submit:(params)=>{
        return $$.post(baseUrl+'submit',params)
    }
}